<template>
	<AdminLayout>
		<div class="flex flex-row items-center mb-8">
			<p class="admin-center-subtitle">Support Messages</p>
		</div>

		<PortalDataTable
			ref="table"
			:endpoints="endpoints"
		>
			<template #created_at="data">
				<div class="whitespace-nowrap">
					{{ Format.date(data.value.created_at) }}
				</div>
			</template>

			<template #user_name="data">
				<div class="userpilot-mask whitespace-nowrap">
					{{ data.value.user_name }}
				</div>
			</template>

			<template #email_address="data">
				<div class="userpilot-mask whitespace-nowrap">
					{{ data.value.email_address }}
				</div>
			</template>

			<template #subject="data">
				<div class="userpilot-mask whitespace-nowrap">
					{{ data.value.subject }}
				</div>
			</template>

			<template #message="data">
				<div class="userpilot-mask whitespace-pre-wrap">
					{{ data.value.message }}
				</div>
			</template>
		</PortalDataTable>
	</AdminLayout>
</template>

<script setup lang="js">
import AdminLayout from '@/layouts/AdminLayout.vue'
import PortalDataTable from '@/components/DataTable/PortalDataTable.vue'
import { Format } from '@/models/utils/FormatUtils.js'
import { DataTableEndpointDefinition } from '@/models/datatable/DataTableEndpointDefinition.js'

const columns = [
	{ field: "created_at", title: "Message Date", width: '1%' },
	{ field: "user_name", title: "Name", sort: false, width: '20%', search: true }, // sort: false kinda sucks here
	{ field: "email_address", title: "Email Address", width: '20%', search: true },
	{ field: "subject", title: "Subject", width: '1%', search: true },
	{ field: "message", title: "Message", search: true },
]

const endpoints = [
	new DataTableEndpointDefinition({
		endpointRoute: 'users/support/messages',
		initialSortColumn: 'created_at',
		searchPlaceholder: 'Search by name, email, subject or message',
		fullTextSearch: false,
		columns: columns,
	})
]

</script>
